/* eslint-disable no-console */
import { getMapLayersMatchedToLayerList } from ".";

/** Can confirm output of mapbox layers are what we expect from the ordered list
 * */
export function debugMapboxSorting(mapboxLayers, mapboxSources, orderedLayerList) {
  const matchedMapboxLayers = getMapLayersMatchedToLayerList({
    layerList: orderedLayerList,
    mapboxLayers: mapboxLayers
  });

  // Compare the order of layer names, not the order property values
  // matchedMapboxLayers will have sequential indices (0,1,2,3...) based on current mapbox position
  // orderedLayerList has the desired order numbers from the layer list
  // We need to check if the sequence of names matches
  const currentLayerNames = matchedMapboxLayers.map((l) => l.name);
  const expectedLayerNames = orderedLayerList.map((l) => l.name);
  const isOrderedLayerDataSame =
    JSON.stringify(currentLayerNames) === JSON.stringify(expectedLayerNames);

  console.log("Mapbox layers:", mapboxLayers);
  console.log("Mapbox sources:", mapboxSources);
  console.log("Mapbox layers after sort: ", matchedMapboxLayers);
  console.log("Expected layer order: ", orderedLayerList);
  console.log("Current layer name order:", currentLayerNames);
  console.log("Expected layer name order:", expectedLayerNames);
  console.log(
    `Layers matching the layer list have been sorted: ${
      isOrderedLayerDataSame ? "Successfully" : "Unsuccessfully"
    }.`
  );
}
